import UserTagging from './UserTagging';

export default UserTagging;
